import { ReactComponent as SuccessIcon } from '@basqet-dashboard/common/assets/icons/success.svg';
import { Button } from '@basqet-dashboard/common/components';
import { useNavigateTo } from '@basqet-dashboard/common/utils';
import React from 'react';

const KycSuccess = () => {
  const { navigateTo } = useNavigateTo();
  return (
    <div className="kyc__status">
      <div className="card kyc__status--success  text-center">
        <header className="card__header">
          <SuccessIcon />
          <h3>Successful!</h3>
        </header>
        <div className="card__body">
          <p>Your account has been verified and you can now make transactions</p>
        </div>
        <Button isFull onClick={() => navigateTo('/')}>
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
};

export { KycSuccess };
